import React from 'react'
const EditorContext = React.createContext(null)

export default EditorContext
